module.exports = __webpack_public_path__ + "img/entrees.82b6932d.png";